import { AiFillDelete } from "react-icons/ai";
import { TiPencil } from "react-icons/ti";
import { HiOutlineArrowsRightLeft } from "react-icons/hi2";

const DeleteIcon = AiFillDelete;
const EditIcon = TiPencil;
const ShareIcon = HiOutlineArrowsRightLeft; 


export { DeleteIcon, EditIcon, ShareIcon };
